var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.98 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.44a14.78 14.78 0 00-2.52 1.33 12 12 0 0019 2.69 14.49 14.49 0 00-9-5 .2.2 0 01-.17-.25v-.13a.39.39 0 01.27-.26 10 10 0 013.33.27.22.22 0 00.24-.12l.28-.62a.19.19 0 00-.06-.25.22.22 0 01.16-.39 3.62 3.62 0 002.63-.65c1.17-1 .92-2.77.72-4.19a10.86 10.86 0 01-.13-1.25c-.05-3-1.17-3-8.45-2.9a5.63 5.63 0 00-4.44 2c-2.25 2.7-2 7.39-1.78 9.34v.11a.23.23 0 01-.08.27z",
    fill: "#37b07f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.41 11H4.11l-.54-3.12h16.24z",
    fill: "#010202",
    stroke: "#010202",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1A11 11 0 111 12 11 11 0 0112 1m0-1a12 12 0 1012 12A12 12 0 0012 0z",
    fill: "#35b07f"
  })))));
}

export default __webpack_public_path__ + "86af5b499a74a64c11cd2b8dd594e3ee.svg";
export { SvgAvatar as ReactComponent };